import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex min-h-screen flex-col items-center justify-center bg-background-100 px-4 text-center">
      <h1 className="select-none font-heading text-7xl font-black text-background-300 md:text-[9rem]">
        404
      </h1>
      <div className="relative z-10 -mt-4">
        <p className="font-heading text-lg font-semibold text-foreground-900">页面走丢了</p>
        <p className="mt-2 font-mono text-sm text-foreground-400">{location.pathname}</p>
        <p className="mt-4 text-sm text-foreground-500">
          你要找的页面可能已被移除或链接有误。
        </p>
        <Link
          to="/"
          className="mt-6 inline-flex items-center gap-2 rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 hover:bg-primary-600 cursor-pointer whitespace-nowrap"
        >
          <i className="ri-home-4-line" />
          返回首页
        </Link>
      </div>
    </div>
  );
}